import React from "react";
import { Icon, Button, CircularProgress } from "@mui/material";

function MobileFileUploadInput({
  onFilesSelected,
  loading,
  accept,
  message = "Tap to Select Files",
  subMessage = ""
}) {
  return (
    <div className="w-full flex flex-col items-center relative p-24 mt-14 border-2 border-dashed !border-blue-600/50 outline-none transition hover:!border-blue-600 focus:!border-blue-600 cursor-pointer w-full max-w-md mx-auto min-h-[180px]">
      {/* Hidden File Input */}
      <input
        id="file-upload-mobile"
        type="file"
        multiple
        accept={accept}
        onChange={async (e) => {
          const files = Array.from(e.target.files);
          if (files.length) {
            await onFilesSelected(files);
          }
        }}
        disabled={loading}
        style={{ display: "none" }}
      />

      {/* Label Display Area */}
      {!loading ? (
        <label
          htmlFor="file-upload-mobile"
          className="cursor-pointer w-full flex flex-col items-center"
        >
          <Icon fontSize="large" color="action" sx={{ fontSize: "6rem" }}>
            cloud_upload
          </Icon>
          <p>{message}</p>
          <p className="text-gray-500 text-center">{subMessage}</p>
        </label>
      ) : (
        <div className="absolute inset-0 bg-white bg-opacity-100 z-10 flex items-center justify-center">
          <CircularProgress color="inherit" />
        </div>
      )}
    </div>
  );
}

export default MobileFileUploadInput;
